import React, { useState } from 'react';
import i18n from '../../../locales/index';
import { Row, Col, Container, Image, FormControl } from 'react-bootstrap'
import './index.css'
import TitleBold from '../../../components/Text/TitleBold';
import TitleLight from '../../../components/Text/TitleLight';
import MainStyles from '../../../styles/MainStyles';
import TextLink from '../../Text/TextLink';
import WhiteButton from '../../../components/Buttons/WhiteButton';
import WhiteButtonOutline from '../../../components/Buttons/WhiteButtonOutline';
import GarageList from '../../Garage';
import ModelDetails from '../../ModelDetails';
import {removeVehicleData} from '../../../services/Vehicles'
import LogoutIcon from '../../../assets/images/logout.svg'
import AddIcon from '../../../assets/images/add.svg'
import { getLogoutUrl } from '../../../shared/constants';
import { Modal, Spinner } from 'react-bootstrap'

let { basePath } = require('../../../shared/constants');


const _removeVehicleData = async (selectedModel) => {
  const response = await removeVehicleData(selectedModel.modelDetails.id);
 
}

const replaceVehicle = (mensage, name)=>{
  var text = mensage.replace('vehicle_name',name)
  return text;
}


const CarHeader = ({ history, selectedModel, garageList, selectModel, userData }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <Container className='main-container' fluid="xl" style={{ ...MainStyles.containerGradient }}>
      { garageList.length > 1 &&
        <GarageList
          vehicleModels={garageList}
          selectModel={(vin) => selectModel(vin)}
          selectedModel={selectedModel}
        />
      }
      <Row>
        <Col md={{ size: 8, offset: 1 }} xs={{ size: 8, offset: 1 }}>
          <TitleBold
            text={i18n.t('general.my_vw_title')}
            color={MainStyles.colors.white}
            ownClass={'car-header-title'}
            size={'bigger'} />

          <TitleBold
            text={(selectedModel && selectedModel.modelDetails) ? selectedModel.modelDetails.modelName : ' '}
            color={MainStyles.colors.white}
            ownClass={'car-header-name'}
            size={'bigger'}/>
            
           
          <div style={{ marginTop: '32px' }}>
            <Image
              src={AddIcon}
            />
            <TextLink
              text={i18n.t('general.add_new_vehicle')}
              separator={'block-link block-link-icon'}
              onClick={() => {

                history.push({
                  pathname: `/vehicle-form`,
                  state: {
                    "document": userData.document,
                    "name": userData.name
                  }
                })
              }}
            />
          </div>

          <TextLink
            text={i18n.t('general.garantee')}
            separator={'block-link'}
            onClick={() => {
              window.open('https://www.vw.com.br/pt/servicos-e-acessorios/manuais-e-garantia.html', '_blank')
            }}
          />

          <TextLink
            text={i18n.t('general.rmv_vehicle')}
            separator={'block-link'}
            onClick={handleShow}
          />
          <Modal style={{with:'60' , height:'80'}}
            show={show} onHide={handleClose}>
            <Container className='car-header-remove'>

                <Col style={{ textAlign: 'justify' }}>
                <TitleBold
                  text={replaceVehicle(i18n.t('general.rmv_vehicle_msg'),(selectedModel && selectedModel.modelDetails) ? selectedModel.modelDetails.modelName : ' ')}
                  color={MainStyles.colors.white}
                  ownClass={'car-header-title'}
                  size={'bigger'} />
              </Col>
              
              <Col>
                <Col style={{ textAlign: 'center', marginTop: '10%' }}>
                 
                  <WhiteButton
                    text={i18n.t('general.confirm')}
                    style={{margin: '20px'}}
                    isRounded={true}
                    onClick={() => {
                      const result =  _removeVehicleData(selectedModel);
                      if(result){
                        history.push({
                          pathname: `/login-redirect`,
                          state: {
                            "document": userData.document,
                            "name": userData.name
                          }
                        })
                      }
                    }}
                  />
                  </Col>
                  <Col style={{ textAlign: 'center', marginTop: '3%' }}>
                   <WhiteButtonOutline
                    text={i18n.t('general.no_back')}
                    isRounded={true}
                    onClick={() => {
                      setShow(false);
                    }}
                  />
                </Col>
                <Col style={{ textAlign: 'center', marginTop: '10%' }}>
                </Col>
              </Col>
            </Container>

          </Modal>


          {selectedModel && selectedModel.modelDetails &&
            <div>
              <ModelDetails
                selectedModel={selectedModel.modelDetails}
              />
              <Image
                className='car-image'
                src={selectedModel.modelDetails.photo}
              />
            </div>
          }

          <button
            className='btn-logout'
            onClick={() => {
              window.location.href = getLogoutUrl()
            }}>
            <TitleLight
              text={'Sair'}
              color={MainStyles.colors.blue_2}
              size='medium'
            />
            <Image
              src={LogoutIcon}
            />
          </button>
        </Col>
      </Row>
    </Container>
  )
}

export default CarHeader
